var _ellipse, _ellipse2, _ellipse3, _path, _script;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDoneAnimation = function SvgDoneAnimation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e0eYW28IVpc1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 375 220",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "e0eYW28IVpc2",
    rx: 102.394727,
    ry: 102.394727,
    transform: "matrix(-.866879 0.522426-.522426-.866879 187.5 110)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6,
    strokeOpacity: 0.1,
    strokeMiterlimit: 1,
    strokeDashoffset: 1100,
    strokeDasharray: 643.37
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "e0eYW28IVpc3",
    rx: 102.394727,
    ry: 102.394727,
    transform: "matrix(.881429 0.230068-.230068 0.881429 187.5 110)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6,
    strokeOpacity: 0.2,
    strokeMiterlimit: 1,
    strokeDashoffset: 1150,
    strokeDasharray: 643.37
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "e0eYW28IVpc4",
    rx: 102.394727,
    ry: 102.394727,
    transform: "matrix(.233644-.785876 0.784544 0.233248 187.5 110)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6,
    strokeOpacity: 0.5,
    strokeMiterlimit: 1,
    strokeDashoffset: 1180,
    strokeDasharray: 643.37
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "e0eYW28IVpc5",
    d: "M149.256768,110Q187.500001,148.243373,187.5,148.243372l46.716642-61.583325",
    transform: "translate(0 0.364118)",
    opacity: 0,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5,
    strokeOpacity: 0.7,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeDashoffset: 131.38,
    strokeDasharray: 131.382001
  })), _script || (_script = /*#__PURE__*/React.createElement("script", null)));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDoneAnimation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/done_animation.a11c56548a9bc63efd7fb35d232d7265.svg";